import * as React from 'react';
import { useSelector } from 'react-redux';

import { useIsDesktop } from '@cian/valuation-utils-component';

import { Intro } from '../../components/Intro';
import { SaleRentIntro } from '../../components/SaleRentIntro';
import { PartnerIntro } from '../../components/PartnerIntro';
import { formContextObj } from '../FormContainer';
import { selectIntro } from '../../selectors/selectIntro';
import { ENamePartners } from '../../constants/namePartners';

export const IntroContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isDesktop = useIsDesktop();

  const { startQuiz } = React.useContext(formContextObj);

  const {
    fromSaleRent: withSaleRentIntroScreen,
    fromN1: withFromN1,
    fromBankiru: withFromBankiru,
  } = useSelector(selectIntro);

  if (withFromBankiru) {
    return <PartnerIntro partner={ENamePartners.Bankiru} />;
  }

  if (withFromN1) {
    return <PartnerIntro partner={ENamePartners.N1} />;
  }

  if (withSaleRentIntroScreen) {
    return <SaleRentIntro />;
  }

  if (!isDesktop) {
    return <Intro onSubmit={startQuiz} />;
  }

  return null;
};

IntroContainer.displayName = 'IntroContainer';
